import { FormControlLabel, Switch, styled } from '@mui/material';
import { FC, useCallback, useEffect, useState } from 'react';

interface Props {
    label: string;
    handleSelection: (active: boolean) => void;
    active?: boolean;
}

export const SwitchButton: FC<Props> = ({ label, handleSelection, active = false }) => {
    const [checked, setChecked] = useState(active);

    useEffect(() => {
        setChecked(active);
    }, [active]);

    const onChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            setChecked(event.target.checked);
            handleSelection(event.target.checked);
        },
        [handleSelection]
    );

    return (
        <StyledFormControlLabel
            label={label}
            control={<Switch checked={checked} onChange={onChange} data-testid="switch-button" />}
        />
    );
};

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    gap: theme.spacing(2),
    '& .MuiFormControlLabel-label': {
        fontWeight: 'bold',
    },
}));
